import axios from "axios";

export const backendOrigin = process.env.REACT_APP_BACKEND_URL || "";
const API = `${backendOrigin}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

let refreshCall = null;
api.interceptors.response.use((response) => response, async (error) => {
  const body = error.response?.data?.detail;
  const code = body && typeof body === "object" ? body.code : "";
  if (code === "password_change_required") window.dispatchEvent(new Event("password-change-required"));
  const original = error.config || {};
  if (error.response?.status === 401 && !original._retry && !String(original.url || "").includes("/auth/")) {
    original._retry = true;
    try {
      refreshCall = refreshCall || api.post("/auth/refresh");
      await refreshCall;
      refreshCall = null;
      return api(original);
    } catch (refreshError) {
      refreshCall = null;
      window.dispatchEvent(new Event("session-expired"));
    }
  }
  return Promise.reject(error);
});
